/**
 * Conclusion HTML guide.
 */
import React, { Fragment } from "react";
import { useParams } from "react-router-dom";

import { getSectionTitle, getVerticalTitle } from "utils/course";
import { useAsterController } from "context";
import VimeoComponent from "pages/common/VimeoComponent";
import SafeHtml from "pages/common/SafeHtml";

/**
 * Renders concluding HTML blocks for the course.
 *
 * @param {{ xblocks?: Array }} props
 */
const ConclusionGuide = (props) => {
  const { xblocks } = props;

  const { sectionIndex, sequenceIndex, verticalIndex } = useParams();

  const [controller] = useAsterController();
  const { structure } = controller;

  /**
   * Renders one HTML XBlock.
   *
   * @param {Object} block XBlock payload.
   * @returns {JSX.Element}
   */
  const renderHtml = (block) => {
    let htmlText = block.html?.replaceAll(/src="\/static/g, `src="${process.env.REACT_APP_BASE_URL}/assets/courseware/v1/${block.id}/asset-v1:${structure.course_id.replace("course-v1:", "")}+type@asset+block`);
    return (
      <Fragment key={block.id}>
        <div className="mt-4 fsp-28 font-bold ">{block.display_name}</div>
        <SafeHtml className="mt-4" html={htmlText} course />
      </Fragment>
    );
  };

  return (
    <>
      <div className="w-full">
        {xblocks.map((block) => {
          switch (block.type) {
            case "html":
              return <Fragment key={block.id}>{renderHtml(block)}</Fragment>;
            case "video":
            case "videoxblock":
              return (
                <Fragment key={block.id}>
                  {getVerticalTitle(structure, sectionIndex, sequenceIndex, verticalIndex) !== block.display_name && <div className="mt-4 fsp-28 font-bold ">{block.display_name}</div>}
                  <VimeoComponent vimeoId={block.vimeo_id} moduleTitle={getSectionTitle(structure, sectionIndex)} vimeoTitle={block.display_name} />
                </Fragment>
              );
            default:
              return <Fragment key={block.id} />;
          }
        })}
      </div>
    </>
  );
};

export default ConclusionGuide;
